import {
  Stack,
  Button,
  Select,
  TextField,
  Switch,
  Tooltip,
  MenuItem,
  FormControl,
} from "@mui/material";
import { FacilitySetting } from "../services/workplaceSettings";

interface SettingsItemActionProps {
  item: FacilitySetting;
  isLoading: boolean;
}

export function SettingsItemAction({ item, isLoading }: SettingsItemActionProps) {
  const options = Array.from({ length: item.noOfTags ?? 0 }, (_, index) => {
    return {
      label: index + 1,
      value: index + 1,
    };
  });

  if (item.key === "createNfcTag" && !item.hidden) {
    return (
      <Stack direction="row" spacing={1}>
        <FormControl sx={{ minWidth: "80px" }}>
          <Select
            size="small"
            defaultValue={item.defaultValue}
            onChange={(e) => item.onChange?.(e.target.value)}
            disabled={item.disabled || item.noOfTags === 0 || isLoading}
          >
            {options.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Button
          variant="text"
          color="primary"
          onClick={item.onClick}
          disabled={item.disabled || item.noOfTags === 0 || isLoading}
        >
          {item.loading ? "Loading..." : "Save"}
        </Button>
      </Stack>
    );
  }

  if (item.key === "hostedTimeDeviceId" && !item.hidden) {
    return (
      <Stack direction="row" spacing={1}>
        <TextField
          type="number"
          onChange={(e) => item.onChange?.(e.target.value)}
          defaultValue={item.defaultValue}
          disabled={item.disabled || isLoading}
          sx={{ width: "100px" }}
          size="small"
        />
        <Button
          variant="text"
          color="primary"
          onClick={item.onClick}
          disabled={item.disabled || isLoading}
        >
          {item.loading ? "Loading..." : "Save"}
        </Button>
      </Stack>
    );
  }

  const switchComponent = (
    <Switch
      checked={item.checked}
      onChange={(e) => item.onChange?.(e.target.checked)}
      disabled={item.disabled || isLoading}
    />
  );

  if (item.key && item.subtitle && !item.hidden) {
    return (
      <Tooltip title={item.subtitle} placement="top">
        {switchComponent}
      </Tooltip>
    );
  }

  if (item.key && !item.hidden) {
    return switchComponent;
  }

  return <></>;
}
